import classnames from 'classnames/bind'
import LoadingBlock from 'js/components/shared/LoadingBlock'

import styles from './ConditionsPopupRedesign.module.scss'

const cx = classnames.bind(styles);

const ConditionsPopupLoader = () => {
  return (
    <div className={cx('loader')}>
      <div className={cx('head')}>
        <LoadingBlock />
        <LoadingBlock />
      </div>
      <div className={cx('body')}>
        <LoadingBlock style={{width: '50%'}} />
        <LoadingBlock style={{width: '30%'}} />
        <LoadingBlock style={{width: '70%'}} />
        <LoadingBlock style={{width: '50%'}} />
        <LoadingBlock style={{width: '30%'}} />
        <LoadingBlock style={{width: '100%'}} />
      </div>
    </div>
  )
}

export default ConditionsPopupLoader
